import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import Select, {formSelectSizes} from '@adv-mt/mt-form-select'

const FormMake = ({aggregations, initialSearch = {}, options = [], value, onChange}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const placeholder = i18n.t('COMMON_ALL_MAKES')

  const onMakeChange = (e, {value}) => {
    const selectedMake = options.find(make => make.id === value)
    const nextValue = selectedMake && {
      id: selectedMake.id,
      name: selectedMake.label
    }

    onChange(e, {
      field: FILTER_NAMES.MAKE,
      value: nextValue,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.MAKE]
    })
  }

  return (
    <Select
      aggregations={aggregations}
      field={FILTER_NAMES.MAKE}
      initialSearch={initialSearch}
      label={i18n.t('COMMON.MAKE')}
      onChange={onMakeChange}
      options={options}
      placeholder={placeholder}
      size={formSelectSizes.LARGE}
      value={value}
    />
  )
}

FormMake.displayName = 'FormMake'
FormMake.propTypes = {
  aggregations: PropTypes.array,
  initialSearch: PropTypes.shape({
    categoryId: PropTypes.number
  }),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  value: PropTypes.number
}

export default FormMake
